import React, { useState } from "react";
import { makeStyles, createStyles } from "@material-ui/core/styles";
import Brands from "../../Brands";
import { trackMobileNavEvent } from "../../analytics";
var useStyles = makeStyles(createStyles({
    wrapper: {
        position: "fixed",
        bottom: 0,
        width: "100%",
        backgroundColor: "#010414",
    },
    grid: {
        display: "grid",
        gridAutoFlow: "column",
        justifyContent: "center",
        WebkitTapHighlightColor: "transparent",
        color: "#fff",
    },
    links: {
        fontSize: 14,
        lineHeight: "20px",
        color: "#fff",
        padding: "10px 12px",
        cursor: "pointer",
    },
}));
var BottomNav = function (_a) {
    var divisions = _a.divisions, ourBrands = _a.ourBrands;
    var styles = useStyles();
    var _b = useState(false), showBrands = _b[0], setShowBrands = _b[1];
    var handleClick = function () {
        setShowBrands(true);
        trackMobileNavEvent(ourBrands.name);
    };
    return (React.createElement("div", { className: styles.wrapper },
        React.createElement("div", { className: styles.grid },
            divisions.map(function (item, index) { return (React.createElement("a", { key: index, className: styles.links, href: item.url, onClick: function () { return trackMobileNavEvent(item.name, item.url); } }, item.name)); }),
            React.createElement("div", { className: styles.links, onClick: handleClick }, ourBrands.name)),
        showBrands && React.createElement(Brands, { open: showBrands, onClose: function () { return setShowBrands(false); } })));
};
export default BottomNav;
